export default "__VITE_ASSET__CjtOPVzn__"